import { Link, Unlink } from "lucide-react";

const ConnectionCard = ({
  logoSrc,
  altText,
  title,
  description,
  accountType,
  isConnected,
  needsReconnect = false,
  isPending = false,
  onToggleConnection,
  onDisconnect,
  onReconnect,
  isDisconnecting = false,
  isReconnecting = false,
  comingSoon = false,
}) => {
  const buttonClasses = isConnected || isPending
    ? "bg-secondary text-white"
    : needsReconnect
      ? "bg-orange-500 text-white hover:bg-orange-600"
    : "border bg-white text-gray-800 hover:bg-gray-100 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-100 dark:hover:bg-gray-700";
  const label = isConnected
    ? "Connected"
    : isPending
      ? "Connecting"
      : needsReconnect
        ? "Login again"
        : "Connect";

  return (
    <div className="flex flex-col gap-4 rounded-lg border border-gray-200 bg-white p-4 dark:border-gray-800 dark:bg-gray-900 sm:flex-row sm:items-center sm:justify-between sm:px-6 sm:py-4">
      <div className="flex items-start sm:items-center gap-3 sm:gap-4 min-w-0 flex-1">
        <div className="shrink-0 rounded border border-gray-200 bg-white p-1 dark:border-gray-700 dark:bg-gray-800">
          <img
            src={logoSrc}
            alt={altText}
            className="w-6 h-6 sm:w-7 sm:h-7 object-contain"
          />
        </div>

        <div className="min-w-0">
          <h2 className="break-words text-sm font-semibold leading-6 text-gray-800 dark:text-gray-100">
            {title}
          </h2>

          <p className="break-words text-xs leading-5 text-gray-500 dark:text-gray-400">
            {description}
          </p>
        </div>
      </div>

      {comingSoon ? (
        <div className="w-full shrink-0 rounded-lg border border-gray-300 px-3 py-2 text-center text-xs font-semibold text-gray-400 dark:border-gray-700 dark:text-gray-500 sm:w-auto sm:text-left">
          Coming Soon!
        </div>
      ) : (
        <div className="flex flex-col sm:flex-row gap-2 w-full sm:w-auto shrink-0">
          <button
            type="button"
            className={`${buttonClasses} px-3 py-2 font-semibold rounded-lg text-xs flex items-center justify-center gap-1 w-full sm:w-auto shrink-0`}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              if (needsReconnect && onReconnect) {
                onReconnect(accountType);
                return;
              }
              if (!isConnected && !isPending) onToggleConnection(accountType);
            }}
            disabled={isConnected || isPending || isReconnecting}
          >
            <Link size={16} strokeWidth={2.5} />
            <span>{isReconnecting ? "Opening..." : label}</span>
          </button>
          {(isConnected || needsReconnect) && onDisconnect && (
            <button
              type="button"
              className="flex w-full shrink-0 items-center justify-center gap-1 rounded-lg border border-red-200 bg-white px-3 py-2 text-xs font-semibold text-red-600 hover:bg-red-50 dark:border-red-900/70 dark:bg-gray-900 dark:text-red-300 dark:hover:bg-red-950/30 sm:w-auto disabled:opacity-60"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onDisconnect(accountType);
              }}
              disabled={isDisconnecting}
            >
              <Unlink size={16} strokeWidth={2.5} />
              <span>{isDisconnecting ? "Disconnecting..." : "Disconnect"}</span>
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default ConnectionCard;
